const MAP = {
  "Picked Up": "bg-blue-50 text-blue-700 border-blue-200",
  "In Transit": "bg-orange-50 text-orange-700 border-orange-200",
  "Delivered": "bg-green-50 text-green-700 border-green-200",
  "Returned to Client": "bg-red-50 text-red-700 border-red-200",
};

export default function StatusBadge({ status }) {
  return (
    <span
      data-testid={`status-badge-${(status || "").toLowerCase().replace(/\s+/g, "-")}`}
      className={`inline-flex items-center whitespace-nowrap px-2 py-0.5 rounded-sm text-xs font-medium border ${MAP[status] || "bg-slate-50 text-slate-600 border-slate-200"}`}
    >
      {status}
    </span>
  );
}
